type ConfigSection = Record<string, any>;
type ParsedConfig = Record<string, ConfigSection>;

/**
 * Load customer configuration from `/configuration.json`.
 * JSON is parsed natively with `response.json()` — no custom INI parser needed.
 */
export async function loadCustomerConfig(): Promise<ParsedConfig> {
  let response: Response;

  try {
    response = await fetch('/configuration.json', {
      cache: 'no-store',
    });
  } catch (error) {
    console.error('Error fetching configuration');
    return {};
  }

  try {
    const config = await response.json();
    return config as ParsedConfig;
  } catch (error) {
    console.error('Error parsing configuration');
    return {};
  }
}
